"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataComponent = void 0;
var react_1 = __importDefault(require("react"));
var common_1 = require("../../../utils/common");
var getDataComponent = function (item, column, isNestingParent, nestingKeyName, rowIndex) {
    var _a;
    var _b = column.keyNames, keyNames = _b === void 0 ? [] : _b, formatFunction = column.formatFunction, Component = column.Component, _c = column.componentProps, componentProps = _c === void 0 ? {} : _c;
    var columnItem = !isNestingParent && nestingKeyName && rowIndex !== undefined ? (_a = item === null || item === void 0 ? void 0 : item[nestingKeyName]) === null || _a === void 0 ? void 0 : _a[rowIndex] : item;
    var value = (keyNames === null || keyNames === void 0 ? void 0 : keyNames[0]) === '*'
        ? columnItem
        : (keyNames === null || keyNames === void 0 ? void 0 : keyNames.length) === 1
            ? columnItem === null || columnItem === void 0 ? void 0 : columnItem[keyNames === null || keyNames === void 0 ? void 0 : keyNames[0]]
            : keyNames === null || keyNames === void 0 ? void 0 : keyNames.reduce(function (acc, keyName) {
                acc[keyName] = (columnItem === null || columnItem === void 0 ? void 0 : columnItem[keyName]) || (item === null || item === void 0 ? void 0 : item[keyName]);
                return acc;
            }, {});
    var columnData = formatFunction ? formatFunction(value) : !common_1.isArrayOrObject(value) ? value : null;
    var ColumnComponent = Component;
    return ColumnComponent ? react_1.default.createElement(ColumnComponent, __assign({ data: value }, componentProps)) : columnData;
};
exports.getDataComponent = getDataComponent;
